<template>
	<div class="home_wrap">
		<div class="red_top_bg m-flex m-f-between m-pd1">
			<div @click="$router.push('index')">
				<img style="width: 10em;" src="@/assets/images/logo.png" alt="">
			</div>
		</div>
		<van-swipe :autoplay="2500" class="swiper-container text-center" @change="onChange">
			<van-swipe-item v-for="(image, index) in data.banner" :key="index">
				<router-link :to="image.url">
					<img :src="image[lang]">
				</router-link>
			</van-swipe-item>
			<div ref="dian" slot="indicator" class="custom-indicator">
				<div v-for="(img, x) in data.banner" :key="x" :class="x===0?'selected':''" />
			</div>
		</van-swipe>

		<!-- 快捷入口 -->
		<div class="quick_grid">
			<div class="quick_item" @click="$router.push('/invest')">
				<div class="quick_icon recharge">
					<van-icon name="gold-coin-o" />
				</div>
				<p class="quick_title">{{ $t('user.recharge') }}</p>
			</div>
			<div class="quick_item" @click="$router.push('/cash')">
				<div class="quick_icon withdraw">
					<van-icon name="balance-o" />
				</div>
				<p class="quick_title">{{ $t('user.withdraw') }}</p>
			</div>
			<div class="quick_item" @click="$router.push('/kefu')">
				<div class="quick_icon invest">
					<van-icon name="chart-trending-o" />
				</div>
				<p class="quick_title">{{ $t('user.onlineService') }}</p>
			</div>
			<div class="quick_item" @click="$router.push('/order')">
				<div class="quick_icon details">
					<van-icon name="bill-o" />
				</div>
				<p class="quick_title">{{ $t('user.myInvestment') }}</p>
			</div>
			<div class="quick_item" @click="$router.push('/user')">
				<div class="quick_icon user">
					<van-icon name="user-o" />
				</div>
				<p class="quick_title">{{ $t('home.my') }}</p>
			</div>
		</div>

		<div v-show="false" class="work_box">
			<div class="item" @click="$router.push('/sign')">
				<div class="item_img"><img src="../images/about/icon0.png" alt=""></div>
				<p class="item_title">{{$t('index.sign')}}</p>
			</div>
			<div class="item" @click="$router.push('/myTeam')">
				<div class="item_img"><img src="../images/about/icon8.png" alt=""></div>
				<p class="item_title">{{$t('index.invite')}}</p>
			</div>
			<div class="item" @click="$router.push('/invest')">
				<div class="item_img"><img src="../images/about/icon2.png" alt=""></div>
				<p class="item_title">{{$t('index.recharge')}}</p>
			</div>
			<div class="item" @click="$router.push('/cash')">
				<div class="item_img"><img src="../images/about/icon6.png" alt=""></div>
				<p class="item_title">{{$t('index.withdraw')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/8')">
				<div class="item_img"><img src="../images/about/icon1.png" alt=""></div>
				<p class="item_title">{{$t('index.risk')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/13')">
				<div class="item_img"><img src="../images/about/icon5.png" alt=""></div>
				<p class="item_title">{{$t('index.secret')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/12')">
				<div class="item_img"><img src="../images/about/icon11.png" alt=""></div>
				<p class="item_title">{{$t('index.agreement')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/11')">
				<div class="item_img"><img src="../images/index/help.png" alt=""></div>
				<p class="item_title">{{$t('index.aboutUs')}}</p>
			</div>
		</div>
		<div v-show="!loading" class="work_box query">
			<div v-for="i in 10" class="item">
				<div class="item_img" />
				<p class="item_title" />
			</div>
		</div>

		<div class="item_wrap">
			<div class="tabs">
			
			</div>
			<div class="items_3 item_margin">
				<div v-for="i in wealth_data.list" :key="i.id" class="item">
					<div class="item_div1">
						<p>
							{{ i[lang] }}
						</p>
					</div>
					<div class="item_div2">
						<div class="item_rate">
							<p>{{i.rate}}%</p>
							<p>{{$t('utils.dailyIncome')}}</p>
						</div>
						<div class="item_day">
							<p>{{i.day}}{{$t('utils.day')}}</p>
							<p>{{$t('utils.cycle')}}</p>
						</div>
						<div class="item_min">
							<p>{{$t('utils.moneyMark')}}{{i.min}}</p>
							<p>{{$t('utils.startingAmount')}}</p>
						</div>
						<div class="item_max">
							<p>{{$t('utils.moneyMark')}}{{i.max}}</p>
							<p>{{$t('utils.maxAmount')}}</p>
						</div>
					</div>
					<div class="item_div4">
						<van-progress :percentage="i.percent" />
						<div class="item_btn">
							<button v-if="i.percent<100" type="button" @click="buy(i)">{{$t('utils.invest')}}</button>
							<button v-if="i.percent>=100" class="item_btn_over" type="button">{{$t('utils.investOver')}}</button>
						</div>
					</div>
				</div>
			</div>
			<van-dialog
			v-model="show_ts" 
			show-cancel-button
			@confirm="confirm"
			:confirmButtonText="$t('utils.confirm')"
			:cancelButtonText="$t('utils.cancel')"
			>
			<div class="items_3">
				<div class="item">
					<div class="item_div1">
						<p>
							{{ wealth_sku[lang] }}
						</p>
					</div>
					<div class="item_div2">
						<div class="item_rate">
							<p>{{wealth_sku.rate}}%</p>
							<p>{{$t('utils.dailyIncome')}}</p>
						</div>
						<div class="item_day">
							<p>{{wealth_sku.day}}{{$t('utils.day')}}</p>
							<p>{{$t('utils.cycle')}}</p>
						</div>
						<div class="item_min">
							<p>{{$t('utils.moneyMark')}}{{wealth_sku.min}}</p>
							<p>{{$t('utils.startingAmount')}}</p>
						</div>
						<div class="item_max">
							<p>{{$t('utils.moneyMark')}}{{wealth_sku.max}}</p>
							<p>{{$t('utils.maxAmount')}}</p>
						</div>
					</div>
				</div>
			</div>
				<van-field v-model="wealth_number" type="number" :placeholder="$t('item.inputAmount')"/>
			</van-dialog>
        </div>

		<van-dialog 
		v-model="show_tz" 
		show-cancel-button
		@confirm="confirm"
		:confirmButtonText="$t('utils.confirm')"
		:cancelButtonText="$t('utils.cancel')"
		>
		<div class="items_3">
			<div class="item">
				<div class="item_div1">
					<p>
						{{ sku[lang] }}
					</p>
				</div>
				<div class="item_div2">
					<div class="item_rate">
						<p>{{sku.rate}}%</p>
						<p>{{$t('utils.dailyIncome')}}</p>
					</div>
					<div class="item_day">
						<p>{{sku.day}}{{$t('utils.day')}}</p>
						<p>{{$t('utils.cycle')}}</p>
					</div>
					<div class="item_min">
						<p>{{$t('utils.moneyMark')}}{{sku.min}}</p>
						<p>{{$t('utils.startingAmount')}}</p>
					</div>
					<div class="item_max">
						<p>{{$t('utils.moneyMark')}}{{sku.max}}</p>
						<p>{{$t('utils.maxAmount')}}</p>
					</div>
				</div>
		<!--		<p class="m-flex p1 m-pd1-x">{{ $t('shouyi_yj') }}<span class="m-right">{{ (number*1+number*(sku.rate/100)*sku.day).toFixed(2) }}</span></p>
		-->	</div>
		</div>
			<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')"/>
		</van-dialog>
		<van-dialog
		v-model="show_tc" 
		:confirmButtonText="$t('utils.confirm')"
		>
		<div class="popup" v-html="tc_content"></div>
		</van-dialog>
		<div v-if="msg_show" class="kefu" :class="show_kefu?'':'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="@/assets/images/logo2.png">
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field,Tab, Tabs ,Empty
	} from "vant";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Tab).use(Tabs).use(Empty);

	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_kefu: false,
				msg_show: true,
				loading: false,
				icon: [],
				data: {},
				show_img: false,
				show_tz:false,
				show_tc:false,
				tc_content:"",
				number: '',
				sku:[],
				tabs:[
					this.$t('item.all'),
					this.$t('item.tab1'),
					this.$t('item.tab2'),
					this.$t('item.tab3'),
					this.$t('item.tab4'),
					this.$t('item.tab5')
				],
				active:0,
                wealth_data: [],
				listLength: 0,
				show_ts:false,
				wealth_number: "",
				wealth_sku:[]
			};
		},
		created() {
			this.$parent.footer('index');
		},
		mounted() {
				this.start();
			if(this.$router.history.current.query.agent){
				localStorage.setItem('agent', this.$router.history.current.query.agent);
			}
			console.log();
			var that = this;
			document.body.addEventListener("scroll", function() {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			}, false);
			document.addEventListener('click', function(ev) {
				if (ev.target.className != 'kefu_img') {
					that.show_kefu = false;
				}
			}, false);
			var type = 0;
			if(this.$router.history.current.query.type){
				this.active = parseInt(this.$router.history.current.query.type);
				type = this.$router.history.current.query.type;
			}
            this.wealthStart(type);
		},
		methods: {
			kefu_to() {
				if (this.show_kefu) {
					this.$router.push('/kefu');
				}
				this.show_kefu = !this.show_kefu;
			},
			hideDown() {
				this.show_img = false;
				this.$store.commit('setShowAdvert', false);
			},
			start() {
				Fetch('/index/int').then((r) => {
					this.data = r.data;
					this.loading = true;
					console.log(this.data,'this.data')
					const token=localStorage.getItem('token')
					if(r.data.popup.show==1&&!token||r.data.popup.show==1&&token==null){
						this.tc_content = r.data.popup.content;
						this.show_tc = true;
					}
				});
			},
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			buy(item){
				this.sku = item;
				this.show_tz = true;
			},
			confirm(){
				if(!this.number){
					this.$toast(this.$t('item.inputAmount'));
					return false;
				}
				Fetch("/index/item_apply", {
				  id: this.sku.id,
				  money:this.number
				}).then(r => {
				  this.$router.push("/order");
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
			wealthStart(type) {
                Fetch('/index/item_search', {
					name: "",
					index_type:type
                }).then(r => {
                    this.wealth_data = r.data;
					this.listLength = r.data.list.length;
                })
            },
			sort(type){
			   this.wealthStart(type);
			},
			wealthBuy(item){
				this.wealth_sku = item;
				this.show_ts = true;
			},
			wealthConfirm(){
				if(!this.wealth_number){
					this.$toast(this.$t('item.inputAmount'));
					return false;
				}
				Fetch("/index/item_index/item_apply", {
				  id: this.wealth_sku.id,
				  money:this.wealth_number
				}).then(r => {
				  this.$router.push("/order");
				}).catch(err=>{
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.home_wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F6F6F6;
	}
	.red_top_bg {
	    position: relative;
	    top: 0;
	    z-index: 10;
		background-color: transparent;
		color:#fff;
	}
    .search_box {
        width: 80%;
        height: 29px;
        background-color: #f6f6f6;
        border-radius: 17px;
        margin: 8px 40px 0 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

	.swiper-container {
		width: 100%;
		height: 300px;
		margin-top: -44px;
		background: #FFFFFF;
		margin-bottom: 20px;

		.van-swipe-item {
			overflow: hidden;
			img{
				min-width: 100%;
				height: 100%;
			}
		}

		a {
			float: left;
			width: 100%;
			height: 100%;
			position: relative;
			&::after{
				content: '';
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: #00000030;
			}
		}
	}

	.quick_grid {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 94%;
		margin: -30px auto 0;
		padding: 18px 0;
		background: #FFFFFF;
		border-radius: 14px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
		position: relative;
		z-index: 5;

		.quick_item {
			width: 20%;    /* 25% → 20% */
			text-align: center;
			cursor: pointer;
			transition: transform 0.2s;

			&:active {
				transform: scale(0.95);
			}

			.quick_icon {
				width: 46px;
				height: 46px;
				border-radius: 50%;
				margin: 0 auto 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 22px;
				color: #fff;

				&.recharge {
					background: linear-gradient(135deg, #667eea, #764ba2);
					box-shadow: 0 4px 10px rgba(102, 126, 234, 0.35);
				}

				&.withdraw {
					background: linear-gradient(135deg, #f093fb, #f5576c);
					box-shadow: 0 4px 10px rgba(245, 87, 108, 0.35);
				}

				&.invest {
					background: linear-gradient(135deg, #43e97b, #38f9d7);
					box-shadow: 0 4px 10px rgba(67, 233, 123, 0.35);
				}

				&.details {
					background: linear-gradient(135deg, #fa709a, #fee140);
					box-shadow: 0 4px 10px rgba(250, 112, 154, 0.35);
				}

				&.user {
					background: linear-gradient(135deg, #4facfe, #00f2fe);
					box-shadow: 0 4px 10px rgba(79, 172, 254, 0.35);
				}
			}

			.quick_title {
				font-size: 12px;
				color: #333;
				line-height: 1.4;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}

	.work_box {
		background: #FFFFFF;
		padding: 17px 8px 4px 8px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.item {
			width: 25%;
			text-align: center;
			margin-bottom: 10px;
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				img {
					width: 44px;
					height: 44px;
				}
			}

			.item_title {
				width: 100%;
				line-height: 14px;
				font-size: 12px;
				color: #333333;
				text-align: center;
				transform: scale(0.85);
			}
		}
	}

	.work_box.query {
		.item {

			.item_img {
				border-radius: 5px;
				background: #f0f0f0;
			}

			.item_title {
				width: 100%;
				height: 14px;
				margin-left: 0;
				background: #f0f0f0;
			}
		}

	}
	.ads_box_1{
		border-radius: 13px;
		margin-top: 10px;
		text-align: center;
		img{
			width: 95%;
		}
	}
	.ads_box{
		width: 97%;
		border-radius: 13px;
		margin: 10px auto 0 auto;
		display: flex;
		text-align: center;
		img{
			width: 96%;
			border-radius: 5px;
		}
	}
	.items_1,
	.items_2,
	.items_3
	{
		.items_tit {
			border-radius: 5px 5px 0 0 ;
			height: 44px;
			line-height: 44px;
			font-size: 16px;
			color: rgba(0, 0, 0, .8);
			background: #FFFFFF;
			border-bottom: 1px solid #F7F7F7;
			padding: 0 14px;
			display: flex;
			justify-content: space-between;
			.tit_tip{
				display: contents;
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
				margin-left: 10px;
			}
			.tit_more{
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
			}
		}
		.item{
			background: #FFFFFF;
		}
	}
	.items_1 {
		.item{
			padding: 5px;
			box-shadow: 0px -10px 20px #00000010 inset;
			div{
				margin: 20px 0;
			}
			.item_tit{
				text-align: center;
				overflow: hidden;
				p{
					text-overflow:ellipsis;
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
				}
			}
			.item_rate{
				text-align: center;
				color: #000000;
				font-size: 22px;
				font-weight: bold;
			}
			.item_desc{
				display: flex;
				p{
					width: 50%;
					text-align: center;
				}
			}
			.item_btn{
				text-align: center;
				button{
					width: 60%;
					min-width: 60px;
					background: #000000;
					color: #FFFFFF;
					padding: 10px 0px;
					border-radius: 10px;
				}
				.item_btn_over{
					background: #999;
				}
			}
		}
	}
	.items_2 {
		.item{
			display: flex;
			width: 100%;
			text-align: center;
			border-bottom: 1px solid #ECECEC;
			div{
				margin: 15px 0;
			}
			.item_rate{
				width: 20%;
				p{
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
					font-size: 14px;
					color: #000;
				}
				p:nth-child(2){
					color: #999;
				}
			}
			.item_tit{
				width: 55%;
				p{
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
				}
				p:nth-child(2){
					color: #999;
				}
			}
			.item_btn{
				width: 25%;
				button{
					min-width: 60px;
					margin-top: 12px;
					color: #000;
					padding: 5px 5px;
					border-radius: 5px;
					border: 1px solid #000;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
	.items_3 {
		.item{
			margin-bottom: 10px;
			div{
				margin: 5px 0;
			}
			.item_div1{
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;
				p:nth-child(1){
					font-weight: bold;
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
				}
				p:nth-child(2){
					color: #999;
				}
			}
			.item_div2{
				display: flex;
				justify-content: space-between;
				text-align:center;
				font-size: 14px;
				div{
					width: 25%;
					p{
						padding: 5px 0;
					}
				}
				.item_rate{
					p:nth-child(1){
						font-weight: bold;
						color: #000;
					}
					p:nth-child(2){
						color: #999;
					}
				}
				.item_day{
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: #999;
					}
				}
				.item_min{
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: #999;
					}
				}
				.item_max{
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: #999;
					}
				}
			}
			.item_div3{
				color: #999;
				padding: 5px 10px;
			}
			.item_div4{
				padding: 5px 10px;
				display: flex;
				justify-content: space-between;

				div:nth-child(1){
					width: 75%;
					margin-top: 16px;
				}

				.item_btn{
					width: 20%;

					button{
						min-width: 60px;
						color: #000;
						padding: 5px 5px;
						border-radius: 5px;
						border: 1px solid #000;
					}

					.item_btn_over{
						color: #999;
						border: 1px solid #999;
					}
				}
			}
		}
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
</style>